import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import ErrorIcon from '../../../assets/icons/ErrorIcon/ErrorIcon';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

const Input = ({
        prefix,
        label,
        placeholder,
        value,
        fieldName,
        required = false,
        validate = true,
        errorMessage,
        type = 'text',
        disabled = false,
        icon,
        handleChange,
        handleBlur = () => {},
        placeholderRow = false,
        labelWidth = '120px', // Default width for labels
}) => {
        const [isValid, setIsValid] = useState(true);
        const [showPassword, setShowPassword] = useState(false);
        const isPasswordField = type === 'password';
        const inputType = isPasswordField ? (showPassword ? 'text' : 'password') : type;

        useEffect(() => {
                if (!validate) setIsValid(false);
        }, [value, type, validate]);

        return (
                <div className={clsx('flex', placeholderRow ? 'flex-row items-center gap-4' : 'flex-col gap-2')}>
                        <label
                                htmlFor={fieldName}
                                className={clsx(placeholderRow ? 'font-normal text-[16px] leading-[19px]  text-[#232529]' : 'text-sm text-[#344054] font-semibold')}
                                style={placeholderRow ? { minWidth: labelWidth } : {}}>
                                {required && <span className="text-red-500 font-medium">*</span>} {label}
                        </label>
                        <div className="relative w-full">
                                {prefix && <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">{prefix}</span>}
                                <input
                                        id={fieldName}
                                        name={fieldName}
                                        placeholder={placeholder}
                                        type={inputType}
                                        value={value}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={disabled}
                                        className={clsx('w-full h-12 pl-4 pr-12 py-3 border rounded-lg outline-none transition', prefix ? 'pl-8' : 'pl-4', 'focus:border-blue-500 hover:border-blue-500 disabled:bg-[#D0D5DD]', 'placeholder:text-[#667085]', !isValid && 'border-red-500 pr-10')}
                                />
                                <div className="absolute inset-y-0 right-4 flex items-center cursor-pointer">{!isValid ? <ErrorIcon className="w-5 h-5 text-red-500" /> : isPasswordField ? showPassword ? <EyeOutlined onClick={() => setShowPassword(false)} /> : <EyeInvisibleOutlined onClick={() => setShowPassword(true)} /> : icon}</div>
                        </div>
                        {!validate && errorMessage && <div className="flex items-center text-red-500 text-xs mt-1">{errorMessage || 'Please Enter Required Field'}</div>}
                </div>
        );
};

export default Input;
